import useSWR from "swr";

import { SWRType } from "../types/global";
import { authFetcher } from "../utils/auth-fetch";

const useOnlineUser = (autoFetch = false, props: Record<string, any> = {}) => {
  let swrUrl = "online-users";

  const {
    data,
    isLoading: dataLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch ? [swrUrl, props] : null,
    ([url, queryParams]) => authFetcher("GET", url, null, queryParams),
    {
      refreshInterval: 20000,
      onErrorRetry: (error) => {
        if (error.status === 404) return;
      },
    },
  );

  return { data, dataLoading, mutate, error };
};

export default useOnlineUser;
